const ua = window.navigator.userAgent || window.navigator.vendor || window.opera

// 是否为智能设备
export const IS_SMART_DEVICE = (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua)

// 是否为 IOS 浏览器
export const IS_IOS_BROWSER = (/iPhone|iPod|iPad/).test(ua)

// 是否为 Android 浏览器
export const IS_ANDROID_BROWSER = (/Android/).test(ua)

// PC浏览器, 非智能设备
export const IS_NOT_SMART_DEVICE = !IS_SMART_DEVICE

// 微信内
export const IS_WECHAT_APP = (/MicroMessenger/).test(ua)

// 21RVAPP 内置浏览器
export const IS_APP_WEBVIEW = (/Enjoyrv/).test(ua)

// iPhone 内置浏览器
export const IS_IOS_APP = IS_APP_WEBVIEW && (/iPhone|iPod|iPad/).test(ua)

// Android 内置浏览器
export const IS_ANDROID_APP = IS_APP_WEBVIEW && (/Android/).test(ua) && (/Enjoyrv/).test(ua)

// 智能设备, 但非APP内置浏览器
export const IS_SMART_DEVICE_BROWSER_ONLY = IS_SMART_DEVICE && !IS_APP_WEBVIEW

// 访问设备来源
export const getDeviceType = function () {
  if (IS_IOS_APP) {
    return '21RV_APP_IOS'
  }
  if (IS_ANDROID_APP) {
    return '21RV_APP_ANDROID'
  }
  if (IS_WECHAT_APP && IS_ANDROID_BROWSER) {
    return 'WECHAT_APP_ANDROID'
  }
  if (IS_WECHAT_APP && IS_IOS_BROWSER) {
    return 'WECHAT_APP_IOS'
  }
  if (IS_NOT_SMART_DEVICE) {
    return 'PC_BROWSER'
  }
  if (IS_IOS_BROWSER) {
    return 'IOS_BROWSER'
  }
  if (IS_ANDROID_BROWSER) {
    return 'ANDROID_BROWSER'
  }
  if (IS_SMART_DEVICE) {
    return 'UNKNOWN_SMART_DEVICE'
  }
  return ''
}
